(function() {
  var config = window.MG_PROMO_CONFIG || {};
  var apiUrl = config.apiUrl || 'https://www.medicalguardian.com/rebrand/ci_app_csrf';
  var defaultAid = config.defaultAid != null ? config.defaultAid : '';
  var cookieDays = config.cookieMaxAgeDays != null ? config.cookieMaxAgeDays : 1;
  var legacyDefaultAids = config.legacyDefaultAids && config.legacyDefaultAids.length
    ? config.legacyDefaultAids
    : ['4', '5552'];
  var siteDefaultAid = config.siteDefaultAid != null ? String(config.siteDefaultAid).trim() : '5214';
  var quizDefaultAid = config.quizDefaultAid != null ? String(config.quizDefaultAid).trim() : '5754';
  var pageDefaultAid = defaultAid != null ? String(defaultAid).trim() : '';

  function getParam(name) {
    var match = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim() : '';
  }

  function getCookie(name) {
    var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return v ? v.pop().trim() : '';
  }

  function getCookieDomain() {
    try {
      var host = typeof window !== 'undefined' && window.location && window.location.hostname ? window.location.hostname : '';
      if (host === 'mobilehelp.com' || host.indexOf('.mobilehelp.com') > -1) {
        return ';domain=.mobilehelp.com';
      }
    } catch (e) {}
    return '';
  }

  function clearCookieHostOnly(name) {
    document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;Max-Age=0';
  }

  function setCookie(name, value, days) {
    var domain = getCookieDomain();
    if (domain) {
      clearCookieHostOnly(name);
    }
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/' + domain + ';expires=' + d.toUTCString() + ';SameSite=Lax';
  }

  // Single source of truth for how long a stored aid stays valid: cookieDays from
  // the moment it was FIRST set, not renewed on every page view (was a sliding window).
  var AID_TS_KEY = '_mg_aid_ts';
  var aidMaxAgeMs = cookieDays * 24 * 60 * 60 * 1000;

  function getAidAgeMs() {
    try {
      var ts = parseInt(localStorage.getItem(AID_TS_KEY), 10);
      if (!ts) return null;
      return Date.now() - ts;
    } catch (e) {
      return null;
    }
  }

  function isAidExpired() {
    var age = getAidAgeMs();
    return age == null || age >= aidMaxAgeMs;
  }

  /** Wipes every store that could resurrect an expired aid — cookies, localStorage
   * (value + timestamp), and sessionStorage — so nothing falls through to a stale value. */
  function clearStoredAid() {
    setCookie('aid', '', -1);
    setCookie('_mg_aid', '', -1);
    try {
      localStorage.removeItem('_mg_aid');
      localStorage.removeItem(AID_TS_KEY);
      sessionStorage.removeItem('aid');
    } catch (e) {}
  }

  /** Writes aid to cookies/localStorage/sessionStorage. Only (re)starts the
   * cookieDays clock when the value actually changed or the previous one
   * expired — an unchanged value's original expiry is left to run out. */
  function persistAid(param) {
    if (!validParam(param)) return;
    var storedAid = null;
    try {
      storedAid = localStorage.getItem('_mg_aid');
    } catch (e) {}
    var expired = isAidExpired();
    var isNewValue = storedAid !== param;

    if (isNewValue || expired) {
      setCookie('aid', param, cookieDays);
      setCookie('_mg_aid', param, cookieDays);
      try {
        localStorage.setItem('_mg_aid', param);
        localStorage.setItem(AID_TS_KEY, String(Date.now()));
      } catch (e) {}
    }

    setCookie('_is_shopify', '1', cookieDays);
    try {
      sessionStorage.setItem('aid', param);
    } catch (e) {}
  }

  function validParam(p) {
    return p && p !== 'undefined' && p !== 'null';
  }

  function isLegacyStoredAid(p) {
    if (!validParam(p)) return false;
    var s = String(p).trim();
    for (var i = 0; i < legacyDefaultAids.length; i++) {
      if (String(legacyDefaultAids[i]).trim() === s) return true;
    }
    return false;
  }

  /** When this template's defaultAid differs from site default, do not reuse site default from storage (e.g. quiz vs rest of site). */
  function isSiteDefaultCarriedToQuizPage(p) {
    if (!validParam(p) || !pageDefaultAid || !siteDefaultAid) return false;
    if (pageDefaultAid === siteDefaultAid) return false;
    return String(p).trim() === siteDefaultAid;
  }

  /** On normal pages (site default), do not keep quiz default from storage after visiting the quiz. URL ?aid= still wins above. */
  function isQuizDefaultCarriedToNonQuizPage(p) {
    if (!validParam(p) || !quizDefaultAid || !siteDefaultAid || !pageDefaultAid) return false;
    if (pageDefaultAid !== siteDefaultAid) return false;
    return String(p).trim() === quizDefaultAid;
  }

  function acceptStoredAid(p) {
    return validParam(p) &&
      !isLegacyStoredAid(p) &&
      !isSiteDefaultCarriedToQuizPage(p) &&
      !isQuizDefaultCarriedToNonQuizPage(p);
  }

  function resolveAid() {
    var p = getParam('aid');
    if (validParam(p)) {
      return p;
    }

    if (isAidExpired()) {
      clearStoredAid();
      return defaultAid != null ? defaultAid : '';
    }

    p = getCookie('aid');
    if (acceptStoredAid(p)) {
      return p;
    }
    p = getCookie('_mg_aid');
    if (acceptStoredAid(p)) {
      return p;
    }
    try {
      p = localStorage.getItem('_mg_aid');
      if (acceptStoredAid(p)) {
        return p;
      }
      p = sessionStorage.getItem('aid');
      if (acceptStoredAid(p)) {
        return p;
      }
    } catch (e) {}
    return defaultAid != null ? defaultAid : '';
  }

  function formatPhoneNumber(number) {
    if (!number) return '';
    var digits = String(number).replace(/\D/g, '').replace(/^1/, '');
    var m = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    return m ? m[1] + '-' + m[2] + '-' + m[3] : number;
  }

  function formatLinkNumber(number) {
    if (!number) return '';
    var digits = String(number).replace(/\D/g, '').replace(/^1/, '');
    var m = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    return m ? m[1] + '-' + m[2] + '-' + m[3] : number;
  }

  function getPhoneDigits(number) {
    if (!number) return '';
    return String(number).replace(/\D/g, '');
  }

  function isValidPhone(value) {
    if (value == null || value === '') return false;
    var digits = String(value).replace(/\D/g, '');
    return digits.length >= 10;
  }

  function extractDisplayNumber(data) {
    if (!data || typeof data !== 'object') return '';
    var results = data.results || data;
    var keys = ['display_number', 'display_number_phone', 'phone_number', 'phone', 'number', 'contact_phone', 'cs_phone'];
    for (var i = 0; i < keys.length; i++) {
      var val = results[keys[i]];
      if (val != null && val !== '') {
        var s = String(val).trim();
        if (isValidPhone(s)) return s;
      }
    }
    if (typeof results === 'object') {
      for (var k in results) {
        if (results.hasOwnProperty(k) && /phone|number|tel/i.test(k)) {
          var v = results[k];
          if (v != null && v !== '' && isValidPhone(v)) return String(v).trim();
        }
      }
    }
    if (data.display_number && isValidPhone(data.display_number)) return String(data.display_number).trim();
    if (data.phone_number && isValidPhone(data.phone_number)) return String(data.phone_number).trim();
    return '';
  }

  function isPhoneLike(text) {
    if (!text || typeof text !== 'string') return false;
    var digits = text.replace(/\D/g, '');
    return digits.length >= 10;
  }

  var STORAGE_AID_PHONES = '_mg_aid_phones';
  var trackingParams = [
    'aid','subid','subid1','subid2',
    'gclid','fbclid','msclkid',
    'utm_source','utm_medium','utm_campaign',
    'p4','forbes_tid','gaVisitor'
  ];

  function getAidPhonesMap() {
    try {
      var raw = localStorage.getItem(STORAGE_AID_PHONES);
      if (!raw) return {};
      var map = JSON.parse(raw);
      return typeof map === 'object' && map !== null ? map : {};
    } catch (e) {
      return {};
    }
  }

  function setPhoneForAid(aid, displayNumber) {
    if (!validParam(aid) || !validParam(displayNumber)) return;
    try {
      var map = getAidPhonesMap();
      map[aid] = displayNumber;
      localStorage.setItem(STORAGE_AID_PHONES, JSON.stringify(map));
    } catch (e) {}
  }

  function getPhoneForAid(aid) {
    if (!validParam(aid)) return '';
    var map = getAidPhonesMap();
    return map[aid] || '';
  }

  function setCartPhoneAttribute(displayNumber) {
    if (!validParam(displayNumber)) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { mg_phone: displayNumber } })
      }).catch(function() {});
    } catch (e) {}
  }

  function replaceSitePhones(displayNumber, formattedNumber) {
    if (!displayNumber) return;
    var digits = getPhoneDigits(displayNumber);
    if (digits.length < 10) return;
    if (!formattedNumber) formattedNumber = formatPhoneNumber(displayNumber);

    var telHref = 'tel:' + digits;

    function replacePhoneTextInNode(node, newNumber) {
      if (node.nodeType === 3) {
        var text = (node.textContent || '').trim();
        if (isPhoneLike(text)) {
          node.textContent = newNumber;
        }
        return;
      }
      if (node.nodeType === 1 && node.childNodes && node.childNodes.length) {
        for (var i = 0; i < node.childNodes.length; i++) {
          replacePhoneTextInNode(node.childNodes[i], newNumber);
        }
      }
    }

    document.querySelectorAll('a[href^="tel:"]').forEach(function(link) {
      link.setAttribute('href', telHref);
      var phoneEl = link.querySelector('.mh-dynamic-phone');
      if (phoneEl) {
        phoneEl.textContent = formattedNumber;
      } else if (link.children.length === 0) {
        var text = (link.textContent || '').trim();
        if (isPhoneLike(text)) {
          link.textContent = formattedNumber;
        }
      } else {
        replacePhoneTextInNode(link, formattedNumber);
      }
    });

    document.querySelectorAll('.mh-dynamic-phone').forEach(function(el) {
      el.textContent = formattedNumber;
    });

    window.MG_PROMO_PHONE = { digits: digits, formatted: formattedNumber };
  }

  function applyStoredDisplayNumber(aid) {
    if (!validParam(aid)) return;
    var stored = getPhoneForAid(aid);
    if (!stored || !validParam(stored)) return;
    setCookie('_mg_phone', stored, cookieDays);
    var formatted = formatPhoneNumber(stored);
    if (formatted) replaceSitePhones(stored, formatted);
    setCartPhoneAttribute(stored);
  }

  function escapeAttr(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderContainer(param, data) {
    var results = data.results || {};
    var token = data.token != null ? data.token : '';
    var promoCode = results.promo_code != null ? results.promo_code : '';
    var displayNumber = extractDisplayNumber(data) || (results.display_number != null ? String(results.display_number).trim() : '');
    var formattedNumber = formatPhoneNumber(displayNumber);
    var linkNumber = formatLinkNumber(displayNumber);

    var root = document.getElementById('aid-container-placeholder');
    if (!root) return;

    var div = document.createElement('div');
    div.id = 'aid-container';
    div.setAttribute('data-test', 'mg-test');
    div.setAttribute('data-aid', escapeAttr(param));

    var inputs = [
      { id: 'csrf_token', name: 'X-CSRF-TOKEN', value: token },
      { id: 'promo_code', name: 'promo_code', value: promoCode },
      { id: 'display_number', name: 'display_number', value: displayNumber },
      { id: 'formatted_number', name: 'formatted_number', value: formattedNumber },
      { id: 'link_number', name: 'link_number', value: linkNumber },
      { id: 'aid', name: 'aid', value: param }
    ];

    inputs.forEach(function(inp) {
      var el = document.createElement('input');
      el.type = 'hidden';
      el.id = inp.id;
      el.name = inp.name;
      el.value = inp.value;
      div.appendChild(el);
    });

    root.parentNode.replaceChild(div, root);

    persistAid(param);

    if (!validParam(displayNumber)) {
      var urlPhone = getParam('mg_phone') || getParam('phone');
      if (validParam(urlPhone) && isValidPhone(urlPhone)) {
        displayNumber = String(urlPhone).trim();
        formattedNumber = formatPhoneNumber(displayNumber);
      }
    }
    if (validParam(displayNumber)) {
      setPhoneForAid(param, displayNumber);
      setCookie('_mg_phone', displayNumber, cookieDays);
      if (param !== defaultAid) {
        replaceSitePhones(displayNumber, formattedNumber);
        setCartPhoneAttribute(displayNumber);
      }
    } else {
      if (param !== defaultAid) {
        applyStoredDisplayNumber(param);
      }
    }

    document.dispatchEvent(new CustomEvent('mgPromoLoaded', {
      detail: { aid: param, displayNumber: displayNumber, formattedNumber: formattedNumber }
    }));
  }

  function applyAidAttribution(param) {
    if (validParam(param)) {
      persistAid(param);
      if (param !== defaultAid) {
        applyStoredDisplayNumber(param);
      }
    } else {
      setCookie('aid', '', cookieDays);
      setCookie('_mg_aid', '', cookieDays);
    }
  }

  function patchAidContainer(aid) {
    if (!validParam(aid)) return false;
    var div = document.getElementById('aid-container');
    if (!div) return false;
    div.setAttribute('data-aid', escapeAttr(aid));
    var input = div.querySelector('input#aid');
    if (input) input.value = aid;
    var byName = div.querySelector('input[name="aid"]');
    if (byName && byName !== input) byName.value = aid;
    return true;
  }

  function loadPromoForAid(param) {
    var url = apiUrl + '?aid=' + encodeURIComponent(param);
    return fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function(res) { return res.text(); })
      .then(function(body) {
        var data;
        try {
          data = JSON.parse(body);
        } catch (e) {
          renderContainer(param, {});
          return;
        }
        if (data && data.results) {
          renderContainer(param, data);
        } else {
          renderContainer(param, {});
        }
      })
      .catch(function() {
        renderContainer(param, {});
      });
  }

  window.MG_PROMO_APPLY_AID = function(aid, opts) {
    opts = opts || {};
    if (!validParam(aid)) return;
    applyAidAttribution(aid);
    patchAidContainer(aid);
    if (opts.refetch) {
      loadPromoForAid(aid);
    }
  };

  function handleTrackingParams() {
    trackingParams.forEach(function(param) {
      var val = getParam(param);
      if (val) {
        setCookie(param, val, 30);
      }
    });

    function populate() {
      trackingParams.forEach(function(param) {
        var val = getCookie(param);
        if (!val) return;
        document.querySelectorAll('form').forEach(function(form) {
          var input = form.querySelector('input[name="' + param + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = param;
            form.appendChild(input);
          }
          input.value = val;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', populate);
    } else {
      populate();
    }
  }

  var leadFormSelector =
    '[data-quiz-form], [data-offers-form], [data-contact-api-form], [data-still-questions-form]';

  function initTrustedFormForLeadForms(formEl) {
    if (window.__mgTrustedFormLoaded) return;
    var form =
      formEl ||
      document.querySelector(leadFormSelector);
    if (!form) return;
    window.__mgTrustedFormLoaded = true;
    var tf = document.createElement('script');
    tf.type = 'text/javascript';
    tf.async = true;
    tf.src =
      'https://api.trustedform.com/trustedform.js?provide_referrer=false&field=curl&l=' +
      new Date().getTime() +
      Math.random() +
      '&invert_field_sensitivity=false';
    form.appendChild(tf);
  }

  window.mgLeadForm = {
    loadTrustedForm: initTrustedFormForLeadForms,
    readTrustedFormFields: function(formEl) {
      var scope = formEl || document;
      var curlEl =
        scope.querySelector('input[name="curl"]') ||
        document.querySelector('input[name="curl"]') ||
        scope.querySelector('#curl_2') ||
        document.querySelector('#curl_2');
      var tokenEl =
        scope.querySelector('#xxTrustedFormToken_2') ||
        document.querySelector('#xxTrustedFormToken_2') ||
        scope.querySelector('input[name="xxTrustedFormToken"]') ||
        document.querySelector('input[name="xxTrustedFormToken"]');
      var pingEl =
        scope.querySelector('#xxTrustedFormPingUrl_2') ||
        document.querySelector('#xxTrustedFormPingUrl_2') ||
        scope.querySelector('input[name="xxTrustedFormPingUrl_2"]') ||
        document.querySelector('input[name="xxTrustedFormPingUrl_2"]');
      return {
        curl: curlEl ? String(curlEl.value || '').trim() : '',
        xxTrustedFormToken: tokenEl ? String(tokenEl.value || '').trim() : '',
        xxTrustedFormPingUrl_2: pingEl ? String(pingEl.value || '').trim() : ''
      };
    },
    waitForTrustedFormCert: function(formEl, maxWaitMs) {
      maxWaitMs = maxWaitMs || 8000;
      var self = this;
      initTrustedFormForLeadForms(formEl);
      return new Promise(function(resolve) {
        var start = Date.now();
        function poll() {
          var fields = self.readTrustedFormFields(formEl);
          if (fields.curl && fields.curl.indexOf('cert.trustedform.com') !== -1) {
            resolve(fields);
            return;
          }
          if (Date.now() - start >= maxWaitMs) {
            resolve(fields);
            return;
          }
          setTimeout(poll, 150);
        }
        poll();
      });
    },
    postSecureLead: function(payload, options) {
      options = options || {};
      var base = 'https://www.medicalguardian.com/submitSecureLead/';
      var campaignId =
        options.campaignId != null ? String(options.campaignId).trim() : '';
      if (!campaignId && payload && payload.aid) {
        campaignId = String(payload.aid).trim();
      }
      if (!campaignId) campaignId = '5754';
      var submitUrl =
        base +
        '?CampaignId=' +
        encodeURIComponent(campaignId) +
        '&Provider=MH%20Marketing%20Indirect&form_type=provider';
      var body = new URLSearchParams();
      for (var k in payload) {
        if (!Object.prototype.hasOwnProperty.call(payload, k)) continue;
        var val = payload[k];
        if (val === undefined || val === null) val = '';
        body.append(k, String(val));
      }
      return fetch(submitUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).then(function(response) {
        return response.text().then(function(text) {
          return { data: text };
        });
      });
    },
    setSubmitButtonLoading: function(btn, isLoading) {
      if (!btn) return;
      var spinner = btn.querySelector('.loading__spinner');
      if (isLoading) {
        btn.disabled = true;
        btn.classList.add('loading');
        btn.setAttribute('aria-busy', 'true');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        btn.disabled = false;
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
        if (spinner) spinner.classList.add('hidden');
      }
    },
    isLeadSubmitFailure: function(responseText) {
      if (!responseText) return true;
      if (responseText === 'Failure') return true;
      try {
        var parsed = JSON.parse(responseText);
        if (parsed && parsed.success === 1) return false;
        if (parsed && (parsed.message === 'success' || parsed.message === 'Success')) return false;
        if (parsed && parsed.message === 'error') return true;
        if (parsed && parsed.error && parsed.error !== 0 && parsed.error !== '0') return true;
        if (parsed && parsed.data && parsed.data.errorMessage) return true;
        return false;
      } catch (e) {
        return false;
      }
    }
  };

  function run() {
    handleTrackingParams();
    initTrustedFormForLeadForms();
    var param = resolveAid();
    applyAidAttribution(param);
    loadPromoForAid(param);
  }

  // Runs as soon as this script loads (sync snippet in body). Deferred bundles
  // (e.g. quiz) execute before DOMContentLoaded, so session/cookies must match
  // resolved AID before those scripts run — not only on DOMContentLoaded.
  (function syncAidImmediately() {
    try {
      var param = resolveAid();
      applyAidAttribution(param);
    } catch (e) {}
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
